export interface NullableNumberRange {
  readonly max: number | null;
  readonly min: number | null;
}

export function parseNumberInputValue(value: string | number): number | null {
  if (value === "" || typeof value !== "number" || !Number.isFinite(value)) return null;
  return value;
}
